
<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="11"
				selector
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="异常渠道">
							<c-select name="channel_id" async @search="searchChannel"></c-select>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_abnormal_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button prepend-icon="tf-check" @click="batchHandle()">确认处理</c-button>
				</template>

				<template #product_info="{data}">
					<m-product-info :name="data.product_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
				</template>

				<template #produce_unique_code="{data}">
					{{data.produce_unique_code}} <c-link color="gray" @click="$copy(data.produce_unique_code)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #produce_imei="{data}">
					{{data.produce_imei}} <c-link v-if="data.produce_imei" color="gray" @click="$copy(data.produce_imei)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #abnormal_channel_names="{data}">
					<div v-if="(data.abnormal_channel_list || []).length" class="m-abnormal-channels">
						<template v-for="(channel, i) in data.abnormal_channel_list">
							<span v-if="channel.sync_fail_reason" :key="i" >
								{{channel.channel_name}}
                                <c-tooltip :tip="channel.sync_fail_reason || ''">
                                    <i class="m-channel-info">!</i>
                                </c-tooltip>
							</span>
							<span v-else :key="i">{{channel.channel_name}}</span>
						</template>
					</div>
					<span v-else>-</span>
				</template>

				<template #handle_state="{data}">
					<c-state dict="ABNORMAL_PRODUCT_STATE" :value="data.handle_state"></c-state>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
    import CState from "@/components/public/state.vue";

	export default {
        components: {CState},
		computed: {
			...mapState(['saleAbnormalHandleStateDic'])
		},

		methods: {
			/*********搜索渠道**********/
			searchChannel(keyword, resolve) {
				this.request({
					url: '/sale/product/channel/options',
					data: {
						keyword: keyword
					},
					success: data => {
						resolve((data || []).map(item => {
							return {
								name: item.channel_name,
								value: item.channel_id
							};
						}));
					}
				});
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

			/*********等级tag样式映射**********/
			levelClass(level) {
				if (!level) return '';
				if (level.indexOf('充新') >= 0) return 'm-tag-good';
				if (level.indexOf('靓机') >= 0) return '';
				if (level.indexOf('小花') >= 0 || level.indexOf('大花') >= 0) return 'm-tag-fair';
				if (level.indexOf('内爆') >= 0 || level.indexOf('外爆') >= 0) return 'm-tag-bad';
				return '';
			},

			/*********批量确认处理**********/
			batchHandle() {
				var selected = this.$refs.view.$refs.list.getData('selected');
				if (!selected.length) {
					this.$message({message: '请先勾选需要处理的记录', type: 'warn'});
					return;
				}
				var validList = selected.filter(item => item.handle_state == 1);
				if (!validList.length) {
					this.$message({message: '请勾选【待处理】状态的记录', type: 'warn'});
					return;
				}
				this.handleAbnormal(validList);
			},

			/*********确认处理**********/
			handleAbnormal(list) {
				if (!list.length) return;
				this.$confirm({
					message: '确认处理所选的' + list.length + '条异常记录吗？',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/sale/product/abnormal/handle',
							data: {
								ids: list.map(item => item.id)
							},
							loading: true,
							success: (data, msg) => {
								this.$message({message: msg, type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product-info {
		line-height: 24px;
		font-size: 13px;
		color: #333;

		.m-product-info-name {
			display: flex;
			align-items: center;
			gap: 4px;
		}
	}

	.m-tag {
		display: inline-block;
		padding: 0 6px;
		height: 20px;
		line-height: 18px;
		font-size: 12px;
		border-radius: 2px;
		border: 1px solid #2b7be4;
		color: #2b7be4;
		background: transparent;

		&.m-tag-good {
			border-color: #19be6b;
			color: #19be6b;
		}
		&.m-tag-fair {
			border-color: #e83e8c;
			color: #e83e8c;
		}
		&.m-tag-bad {
			border-color: #ed3f14;
			color: #ed3f14;
		}
	}

	.m-abnormal-channels {
		display: flex;
		flex-wrap: wrap;
		gap: 8px 12px;
		align-items: center;
		font-size: 13px;
		color: #333;
	}

	.m-channel-info {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 16px;
		height: 16px;
		border-radius: 50%;
		border: 1px solid #ed3f14;
		color: #ed3f14;
		font-size: 12px;
		font-style: normal;
        font-weight: 600;
		cursor: pointer;
		vertical-align: middle;
	}
</style>
